import { render, staticRenderFns } from "./cancelPlatformYmsOrderModal.vue?vue&type=template&id=66329408"
import script from "./cancelPlatformYmsOrderModal.vue?vue&type=script&lang=js"
export * from "./cancelPlatformYmsOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports